(() => {
  const initQuiz = (root) => {
    if (!root || root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    const panel = root.querySelector('[data-quiz-panel]');
    const steps = [...root.querySelectorAll('[data-quiz-step]')];
    const next = root.querySelector('[data-quiz-next]');
    const back = root.querySelector('[data-quiz-back]');
    const progress = root.querySelector('[data-quiz-progress]');
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const results = root.querySelector('[data-quiz-results]');
    const resultGrid = root.querySelector('[data-quiz-result-grid]');
    const summary = root.querySelector('[data-quiz-summary]');
    const restart = root.querySelector('[data-quiz-restart]');
    const stringsNode = root.querySelector('[data-quiz-strings]');
    if (!panel || !steps.length || !next || !results || !stringsNode) return;

    const strings = JSON.parse(stringsNode.textContent);
    const answers = {};
    let current = 0;

    const activeStep = () => steps[current];
    const update = () => {
      steps.forEach((step, index) => {
        step.hidden = index !== current;
      });
      const question = activeStep().querySelector('[data-quiz-answer]')?.dataset.question;
      next.disabled = !question || !answers[question];
      next.textContent = current === steps.length - 1 ? strings.results : strings.next;
      back.hidden = current === 0;
      progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      progressLabel.textContent = strings.progress
        .replace('__current__', current + 1)
        .replace('__total__', steps.length);
    };

    const scoreProduct = (product) => {
      let score = Number(product.dataset.rank || 0) / 100;
      if (product.dataset.length === answers.length) score += 4;
      if (answers.texture === 'any' || product.dataset.texture === answers.texture) score += answers.texture === 'any' ? 1 : 4;
      if (answers.colour === 'any' || product.dataset.colour === answers.colour) score += answers.colour === 'any' ? 1 : 3;
      if (answers.priority === 'any' || product.dataset.priority === answers.priority) score += answers.priority === 'any' ? 1 : 3;
      return score;
    };

    const showResults = () => {
      const products = [...root.querySelectorAll('[data-quiz-product]')]
        .map((element) => ({ element, score: scoreProduct(element) }))
        .sort((a, b) => b.score - a.score)
        .slice(0, 3);

      root.querySelectorAll('[data-quiz-product]').forEach((product) => {
        product.hidden = true;
      });
      products.forEach(({ element }, index) => {
        element.hidden = false;
        element.querySelector('[data-quiz-match]').textContent = index === 0 ? strings.match : '';
        resultGrid.appendChild(element);
      });

      summary.replaceChildren();
      Object.entries(answers).forEach(([question, value]) => {
        const pill = document.createElement('span');
        pill.textContent = strings.labels?.[question]?.[value] || value;
        summary.appendChild(pill);
      });

      panel.hidden = true;
      progress.parentElement.hidden = true;
      progressLabel.hidden = true;
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.addEventListener('click', (event) => {
      const option = event.target.closest('[data-quiz-answer]');
      if (option) {
        const { question, value } = option.dataset;
        answers[question] = value;
        activeStep().querySelectorAll('[data-quiz-answer]').forEach((button) => {
          const selected = button === option;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        next.disabled = false;
        return;
      }

      if (event.target.closest('[data-quiz-next]')) {
        if (next.disabled) return;
        if (current === steps.length - 1) showResults();
        else {
          current += 1;
          update();
        }
        return;
      }

      if (event.target.closest('[data-quiz-back]')) {
        current = Math.max(0, current - 1);
        update();
        return;
      }

      if (event.target.closest('[data-quiz-restart]')) {
        Object.keys(answers).forEach((key) => delete answers[key]);
        root.querySelectorAll('[data-quiz-answer]').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        current = 0;
        results.hidden = true;
        panel.hidden = false;
        progress.parentElement.hidden = false;
        progressLabel.hidden = false;
        update();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    update();
  };

  document.querySelectorAll('[data-wig-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', (event) => initQuiz(event.target.querySelector('[data-wig-quiz]')));
})();
